import { Requester } from './requester';

export const sendMsg = (service, action, params) => {
  return {
    post: (callback = () => { }, failure = (err) => { }) => {
      return Requester.doSendPostRequest(service, action, params, callback, failure)
    },
    get: (callback = () => { }, failure = () => { }) => {
      return Requester.doSendGetRequest(service, action, params, callback, failure)
    },
    put: (callback = () => { }, failure = (err) => { }) => {
      return Requester.doSendPutRequest(service, action, params, callback, failure)
    },
    delete: (callback = () => { }, failure = (err) => { }) => {
      return Requester.doSendDeleteRequest(service, action, params, callback, failure)
    }
  }
}
